.wrapper{position:absolute;top:0;right:0;bottom:0;left:0;z-index:2;background-color:#fff;pointer-events:none;overflow:hidden}.wrapper--transparent{background-color:transparent}
/*# sourceMappingURL=tool-layer.component-EVD6LZPX.css.map */
